import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-41c05904")

_pushScopeId("data-v-41c05904")
const _hoisted_1 = {
  class: "ecu_main",
  id: "ecu"
}
const _hoisted_2 = { class: "ecu_title-success" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("ECU Inspection ")
const _hoisted_4 = { class: "ecu-success" }
const _hoisted_5 = { class: "ecu-success-icon" }
const _hoisted_6 = { class: "ecu-fail-icon" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "ecu_body"
}
const _hoisted_9 = { class: "ecu_title-fail" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("ECU Inspection ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("查询失败")
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "line_main" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (JSON.stringify(_ctx.state.ecuInfo) !== '{}')
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "ecu_body",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toView && _ctx.toView(...args)))
        }, [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode("div", _hoisted_4, [
              _createVNode("span", _hoisted_5, [
                _createVNode("img", {
                  src: require('@/assets/promiseFrame/ecu-normal.png')
                }, null, 8, ["src"]),
                _createTextVNode(_toDisplayString(_ctx.state.normalNum), 1)
              ]),
              _createVNode("span", _hoisted_6, [
                _createVNode("img", {
                  src: require('@/assets/promiseFrame/ecu-abnormal.png')
                }, null, 8, ["src"]),
                _createTextVNode(_toDisplayString(_ctx.state.abnormalNum), 1)
              ]),
              _hoisted_7
            ])
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("span", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.failView && _ctx.failView(...args)))
            }, [
              _hoisted_11,
              _createVNode("img", {
                src: require('@/assets/promiseFrame/ecu-fail.png')
              }, null, 8, ["src"])
            ])
          ])
        ])),
    _hoisted_12
  ]))
})